import {ProductTypes} from '../../utils/typescript-types/products';

import {useSelector} from 'react-redux';
import {selectUserSettingsData} from '../../../redux/reducers/userSettingsReducer';
import useTranslation from '../../hooks/use-translation/use-translation';
import Button from '../button/button';
import DropdownSelect from '../dropdown-select/dropdown-select';
import Info from '../icons-af/info';
import ProductBtnSet from '../product-btn-set/product-btn-set';
import ProductPrice from '../product-price/product-price';
import Rating from '../rating/rating';
import {H5, H6, P} from '../typography/typography';
import {StyledLoading} from './styles';

const printDropdownName = (x: ProductTypes) => {
  const settings = useSelector(selectUserSettingsData);
  const price = x.hasOwnProperty('pricing')
    ? x.pricing[settings.currency].current_price
    : x.prices[settings.currency];

  const artworkDimensions = () =>
    settings.display_units
      ? x[`dimensions_text_short_${settings.display_units}`]
      : x.dimensions_text_short_cm;

  return `${'Print'} on ${x.substrate}: ${artworkDimensions()} (${price})`;
};

const PrintSummary = ({item, product}) => {
  const settings = useSelector(selectUserSettingsData);
  const {t} = useTranslation();

  const artworkDimensions = () =>
    settings.display_units
      ? item[`dimensions_text_${settings.display_units}`]
      : item.dimensions_text_cm;

  return (
    <>
      <H5 style="art" truncate>
        {product.name}
      </H5>

      <P style="p1">
        <span>{t('Limited edition print')}</span>{' '}
        <span title={t('Limited edition fine art print of an original artwork.')}>
          <Info />
        </span>
      </P>

      <H6 style="p1">
        {item.substrate} {t('Print')}&nbsp;
        <br />
        <span>{t('by')}</span>{' '}
        <a href={`/artist/${product.artist_slug}/availability-true/`}>{product.artist_name}</a>
      </H6>
      {product.review_count > 0 && (
        <P style="p1">
          <Rating value={product.summary_seller_rating} size="16px" />{' '}
          <span>{t('{review_count} Artist Reviews', product)}</span>
        </P>
      )}
      <ProductPrice item={item} settings={settings} />

      <P style="p1">{t('From an edition of {edition}', item)}</P>

      <P style="p1">{t(`Size ${artworkDimensions()}`)}</P>

      {item.framed_text && <P style="p1">{item.framed_text}</P>}
    </>
  );
};

const Print = ({prints, product, selected, onChange, pdp = false}: propTypes) => {
  return (
    <>
      {!!prints?.length ? (
        <>
          <PrintSummary item={prints[selected]} product={product} />
          <DropdownSelect
            id="product-select-prints"
            alignment="right"
            value={selected}
            items={prints}
            getName={printDropdownName}
            onChange={onChange}
            disabled={prints.length <= 1}
          />
          {!prints[selected].is_in_stock && (
            <Button disabled wide>
              Sold
            </Button>
          )}
          <ProductBtnSet
            product={product}
            print={prints[selected]}
            hasPrints={prints[selected].is_in_stock}
            hideDislike={pdp}
          />
        </>
      ) : (
        <StyledLoading>
          <p>Loading</p>
        </StyledLoading>
      )}
    </>
  );
};

interface propTypes {
  prints: any[];
  product: object;
  selected: number;
  onChange: (selectedIndex) => any;
  pdp?: boolean;
}

export default Print;

export {printDropdownName, PrintSummary};
